import { render, staticRenderFns } from "./TxRendererProduct.vue?vue&type=template&id=054a3bca&scoped=true&"
import script from "./TxRendererProduct.vue?vue&type=script&lang=js&"
export * from "./TxRendererProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a3bca",
  null
  
)

export default component.exports